/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SpecialFeaturesDownloadAuthenticatedQueryVariables = {
    id: string;
};
export type SpecialFeaturesDownloadAuthenticatedQueryResponse = {
    readonly publication: {
        readonly " $fragmentRefs": FragmentRefs<"DownloadAuthenticatedPublication_data">;
    };
};
export type SpecialFeaturesDownloadAuthenticatedQuery = {
    readonly response: SpecialFeaturesDownloadAuthenticatedQueryResponse;
    readonly variables: SpecialFeaturesDownloadAuthenticatedQueryVariables;
};



/*
query SpecialFeaturesDownloadAuthenticatedQuery(
  $id: ID!
) {
  publication(id: $id) {
    ...DownloadAuthenticatedPublication_data
    id
  }
}

fragment DownloadAuthenticatedPublication_data on Publication {
  id
  title
  topic
  fileName
  filePath
  publishedAt
  visible
  type
  thumbnail
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SpecialFeaturesDownloadAuthenticatedQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Publication",
        "kind": "LinkedField",
        "name": "publication",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DownloadAuthenticatedPublication_data"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SpecialFeaturesDownloadAuthenticatedQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Publication",
        "kind": "LinkedField",
        "name": "publication",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "topic",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fileName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "filePath",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "publishedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "visible",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "thumbnail",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ae1218987d105e4b42e75b59ff5b86b7",
    "id": null,
    "metadata": {},
    "name": "SpecialFeaturesDownloadAuthenticatedQuery",
    "operationKind": "query",
    "text": "query SpecialFeaturesDownloadAuthenticatedQuery(\n  $id: ID!\n) {\n  publication(id: $id) {\n    ...DownloadAuthenticatedPublication_data\n    id\n  }\n}\n\nfragment DownloadAuthenticatedPublication_data on Publication {\n  id\n  title\n  topic\n  fileName\n  filePath\n  publishedAt\n  visible\n  type\n  thumbnail\n}\n"
  }
};
})();
(node as any).hash = 'd79437c395360f3d70731ecf3397233b';
export default node;
